import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import { DataProvider } from "./context";
import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Live from "./views/Live";
import Advanced from "./views/Advanced";
import Settings from "./views/Settings";
import Profile from "./views/Profile";
import { useAuth0 } from "@auth0/auth0-react";
import { AuthInitializer } from "./AuthInitializer";
import history from "./utils/history";
import ProtectedRoute from "./components/ProtectedRoute";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, isAuthenticated, loginWithRedirect, error } = useAuth0();
  document.title = process.env.REACT_APP_TITLE || 'ReVolta';

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    loginWithRedirect(); // This redirects the user to Auth0 login
    return <Loading />;
  }

  return (
    <AuthInitializer>
      <Router history={history}>
        <DataProvider>
          <div id="app" className="d-flex flex-column h-100">
            <NavBar />
            <Container className="flex-grow-1 mt-4 mt-md-5 px-1 px-sm-3">
              <Switch>
                <Route path="/" exact component={Live} />
                <Route path="/profile" component={Profile} />
                <Route path="/geek_corner" component={Advanced} />
                {/* Only admins can access */}

                <ProtectedRoute
                  path="/settings"
                  component={Settings}
                  requiredRole="admin"
                />
              </Switch>
            </Container>
            <Footer />
          </div>
        </DataProvider>
      </Router>
    </AuthInitializer>
  );
};

export default App;